<template>
  <div class="host vm-layout-header">
    <div class="vm-logo">
      <router-link to="/">
        <MainLogo v-if="!$store.state.navigation.site" />
        <div class="hostname" v-else> {{$store.state.clinic.organization.form.title}} </div>
      </router-link>
    </div>
    <button
      v-if="mainNavTree.length"
      @click="burgerClick"
      class="vm-burger-button"
      :class="{ 'vm-has-side': hasSide }"
    >
      <svg
        class="bi bi-list"
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
        />
      </svg>
    </button>
    <Navbar
      class="vm-navbar"
      :tree="mainNavTree"
      :primaryColor="primaryColor"
      :secondaryColor="secondaryColor"
      :showSide="showSide"
    />
    <Userbar class="vm-userbar" />
  </div>
</template>

<script>
import Navbar from './Navbar';
import Userbar from './Userbar';
import MainLogo from '@app/assets/main-logo.svg?inline';

export default {
  components: { Navbar, Userbar, MainLogo },
  props: {
    hasSide: Boolean,
    mainNavTree: Array,
    primaryColor: String,
    secondaryColor: String,
    showSide: Boolean
  },
  methods: {
    burgerClick() {
      this.$emit('burgerClick');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@app/styles/_constants.scss';

.hostname {
   color: #d54d7b;
   font-family: "Great Vibes", cursive;
   font-size: 30px;
   line-height: 24px;
   font-weight: normal;
}
.vm-logo svg {
  width: 60px;
  fill: #fff;
}
.vm-userbar {
  margin-left: auto;
}
.host.vm-layout-header {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  margin: auto;
}
.vm-burger-button.vm-has-side {
  display: block;
  margin: 0 12px;
}
.vm-burger-button {
  display: none;
}
.vm-phone {
  margin-left: auto;
}
a.vm-number {
  color: white;
  text-decoration: none;
}
.vm-burger-button {
  display: none;
  padding: 0;
  border: 0;
  height: 64px;
  width: 64px;
  background-color: transparent;
  transition: background-color 100ms;
  outline: none;
  color: #fff;
}
.vm-burger-button:hover {
  background-color: rgba(0, 0, 0, 0.125);
}
.vm-burger-button svg {
  width: 24px;
  height: 24px;
  fill: white;
}
.vm-burger-button.vm-has-side {
  display: block;
}
@media (max-width: 1200px) {
  .vm-phone {
    display: none;
  }
}
@media (max-width: 1100px) {
  .vm-burger-button {
    display: block;
  }
  .vm-navbar {
    display: none;
  }
}
@media (max-width: 600px) {
  .vm-burger-button {
    display: block;
  }
  a.vm-number {
    display: none;
  }
}
</style>
